/**
 * @typedef {Object} CommentModelType
 * @property {number} id - Unique identifier
 * @property {string} commentText - Comment text or a JSON string
 * @property {string} addedBy - Name of the user who added the comment
 * @property {number} type - Comment type
 * @property {Date} dateCreated - Date comment was created
 */

import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import dayjs from '@/services/date/index'

/**
 * @class
 */
export default class CommentModel {
  /**
   * Create a new CommentModel.
   * @param {CommentModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.commentText = params.commentText
    this.addedBy = params.addedBy
    this.type = params.type
    this.dateCreated = params.dateCreated ? dayjs(params.dateCreated) : null
  }

  /**
   * Get the formatted date created timestamp
   * @returns {string} - The timestamp text
   */
  getDateCreatedTimestamp() {
    if (!this.dateCreated) return ''
    return dayjs(this.dateCreated).format(DateFormatToken.ddddDoMMMMatLT)
  }
}
